import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { StyledVideoConsultationField } from './VideoConsultationField.styled';

type VideoConsultationFieldFormBeanPart = {
   videoConsultation: boolean;
};

type VideConsultationFieldProps = {
   register: BindingCreator<VideoConsultationFieldFormBeanPart>;
};

export const VideoConsultationField = (props: VideConsultationFieldProps): ReactElement => {
   return (
      <StyledVideoConsultationField
         testId={'videoConsultation'}
         label={translationKeys.videoConsultation}
         controller={props.register('videoConsultation')}
      />
   );
};
